import React from 'react';

import Layout from '../../components/Layout';
import SEO from '../../components/SEO';

import MainHeroMassage from '../../components/HomeSections/MainHeroMassage';
import About from '../../components/HomeSections/about';
import Join from '../../components/HomeSections/join';
import Recruitment from '../../components/HomeSections/recruitment';
import Benefits from '../../components/HomeSections/benefits';
import Values from '../../components/HomeSections/values';
import Facilities from '../../components/HomeSections/facilities';
import Sun from '../../components/HomeSections/sun';

export default function index() {
	return (
		<Layout page='home'>
			<SEO title='Trabaja en CCU Argentina' />
			<MainHeroMassage />
			<About />
			<Join />
			<Recruitment />
			<Benefits />
			<Facilities />
			<Values />
			<Sun />
		</Layout>
	);
}
